export default __webpack_public_path__ + "static/media/unKurai.7035838f.webp";